import { User } from './user';

export const BOT_USER_ID = -999;
export const BOT_USER_NAME = 'PartsHub Bot';

export const getInitialsFromNameData = (firstName: string, lastName: string) => {
  return `${firstName[0]}${lastName[0]}`;
};

export const getUserInitials = (user: User) => {
  if (user &&
    user.first_name && user.first_name.length &&
    user.last_name && user.last_name.length) {
    return getInitialsFromNameData(user.first_name, user.last_name);
  }

  return null;
};

export const getUserFullName = (user: User) => {
  return user ? `${user.first_name} ${user.last_name}` : null;
};

